module.exports = __webpack_public_path__ + "img/greenEdit.82390581.svg";